import BlockText from "../block-content/block-text";
import styled from "styled-components";
import tw from "twin.macro";

const OrderedList = styled.ol`
  counter-reset: my-awesome-counter;
  li {
    counter-increment: my-awesome-counter;
    ${tw`flex relative mb-1`}
    &:before {
      content: counter(my-awesome-counter);
      ${tw`font-mono text-blue-200 text-6xl italic leading-none`}
      @media (min-width: 768px) {
        font-size: 6.5rem;
      }
    }
  }
`;

const WhyStudyBlock = (props) => {
  const whyStudyBlock = props.props ?? props.pageBlockGroup;

  return (
    <section key={whyStudyBlock._key} className="py-8 md:py-24 bg-blue-100">
      <div className="max-w-6xl px-4 mx-auto">
        <hr className="w-8 border-yellow-500 border-4 mb-2" />
        <h2 className="text-blue-600 font-bold tracking-tighter text-xl md:text-4xl mb-1 md:mb-6 leading-tight">
          {whyStudyBlock.title}
        </h2>
        <OrderedList className="flex flex-wrap">
          {whyStudyBlock.whyStudy.map((whyStudy) => (
            <li key={whyStudy._key} className="w-full mx-auto md:w-4/12 mb-6">
              <div className="flex">
                <div className="w-full text-sm p-4">
                  <h3 className="text-lg md:text-xl tracking-tight text-blue-500 font-bold">
                    {whyStudy.title}
                  </h3>
                  {whyStudy._rawBody && (
                    <BlockText blocks={whyStudy._rawBody} />
                  )}
                </div>
              </div>
            </li>
          ))}
        </OrderedList>
      </div>
    </section>
  );
};

export default WhyStudyBlock;
